import { render } from "./test.vue?vue&type=template&id=02442ddb"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__